
import Header from '../../components/feature/Header';
import Footer from '../../components/feature/Footer';
import HeroSection from './components/HeroSection';
import AboutSection from './components/AboutSection';
import InfoSection from './components/InfoSection';
import ServicesSection from './components/ServicesSection';
import PerformanceSection from './components/PerformanceSection';
import ContactSection from './components/ContactSection';

export default function Home() {
  return (
    <div className="min-h-screen">
      <Header />
      <main>
        <HeroSection />
        <AboutSection />
        <InfoSection />
        <ServicesSection />
        <PerformanceSection />
        <ContactSection />
      </main>
      <Footer />
    </div>
  );
}
